<template>
  <div class="my-contact-index-div1">
    <table style="width: 100%;" cellspacing="0" cellpadding="0">
      <tr height="50px">
        <td>
          <div class="my-contact-index-div2">
            <span class="my-contact-index-span1">联系我们</span>
          </div>
        </td>
      </tr>
      <tr>
        <td class="my-contact-index-td2">
          <el-row>
            <el-col :span="10">
              <div>
                <img :src="getInfo.contactUrl" style="position: relative; left: 120px;" />
              </div>
            </el-col>
            <el-col :span="14">
              <div class="my-contact-index-div3">
                <span class="my-contact-index-span2">
                  销售部电话：{{getInfo.phone}} {{getInfo.telephone}}（{{getInfo.name}}）<br />
                  传真：{{getInfo.phone}}<br />
                  QQ：{{getInfo.qq}}<br />
                  邮编：{{getInfo.postalCode}}<br />
                  E-mail：{{getInfo.email}}<br />
                  地址：{{getInfo.address}}<br />
                </span>
              </div>
            </el-col>
          </el-row>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
  import Vuex from 'vuex'

  export default {
    name: "ContactIndex",
    data() {
      return {

      };
    },
    components: {},
    methods: {

    },
    computed: {
      ...Vuex.mapGetters(["getInfo"])
    },
    created() {
      this.$store.state.activeIndex = "7";
    }
  }
</script>

<style>
  .my-contact-index-div1 {
    width: 1200px;
    margin: 0 auto;
  }

  .my-contact-index-span1 {
    font-size: 25px;
    font-weight: bold;
    color: white;
  }

  .my-contact-index-div2 {
    width: 260px;
    background: royalblue;
    height: 70px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-top-left-radius: 30px;
    border-top-right-radius: 30px;
  }

  .my-contact-index-div3 {
    margin: 0px auto;
    position: relative;
    top: 30px;
  }

  .my-contact-index-td2 {
    border: 0px hidden;
    background: white;
    text-align: left;
    height: 350px;
  }

  .my-contact-index-span2 {
   font-size: 18px;
  }
</style>



// WEBPACK FOOTER //
// src/components/contact/ContactIndex.vue